import { hasProperty } from './TypeHelpers';

export const isError = (value: unknown): value is Error =>
  value instanceof Error ||
  (typeof value === 'object' &&
    value !== null &&
    hasProperty(value, 'name') &&
    typeof value.name === 'string' &&
    hasProperty(value, 'message') &&
    typeof value.message === 'string' &&
    (!hasProperty(value, 'stack') || typeof value.stack === 'string' || typeof value.stack === 'undefined'));

/**
 * Helper method to convert unknown exception to {@link Error} for logging
 *
 * @param exception
 */
export const toError = (exception: unknown): Error => {
  switch (typeof exception) {
    case 'string':
    case 'number':
    case 'bigint':
    case 'symbol':
    case 'boolean':
      return new Error(exception.toString());
    case 'function':
      return new Error(`[function ${exception.name}]`);
    case 'undefined':
      return new Error('undefined');
    case 'object': {
      if (exception === null) {
        return new Error('null');
      }

      if (isError(exception)) {
        return exception;
      }

      const str = exception.toString();
      if (str !== '[object Object]') {
        return new Error(str);
      }

      return new Error(JSON.stringify(exception));
    }
    default:
      return new Error(`Unknown error [${typeof exception}]: ${JSON.stringify(exception)}`);
  }
};
